import { render, staticRenderFns } from "./CartRepairRegistration.vue?vue&type=template&id=28b06b58&scoped=true&"
import script from "./CartRepairRegistration.vue?vue&type=script&lang=js&"
export * from "./CartRepairRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CartRepairRegistration.vue?vue&type=style&index=0&id=28b06b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b06b58",
  null
  
)

export default component.exports